import { FC, SVGProps } from 'react';

export const ScaleUpIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.25 5.99588C17.2523 5.58168 17.5899 5.24774 18.0041 5.25001L26.0041 5.29391C26.4167 5.29617 26.75 5.63129 26.75 6.0439V13.9816C26.75 14.3959 26.4142 14.7316 26 14.7316C25.5858 14.7316 25.25 14.3959 25.25 13.9816V6.78979L17.9959 6.74999C17.5817 6.74772 17.2477 6.41009 17.25 5.99588ZM6 17.2225C6.41421 17.2225 6.75 17.5582 6.75 17.9725V25.25H14C14.4142 25.25 14.75 25.5858 14.75 26C14.75 26.4142 14.4142 26.75 14 26.75H6C5.58579 26.75 5.25 26.4142 5.25 26V17.9725C5.25 17.5582 5.58579 17.2225 6 17.2225Z"
			fill="currentColor"
		/>
	</svg>
);
